import classnames from 'classnames';
import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import * as Icon from 'react-bootstrap-icons';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { DateNumber, getDateNumber, parseDateNumber } from '../../app/dates';
import { InputEventHandler } from '../../app/types';

import styles from './EntryInput.module.css';

interface DateInputProps {
  value: number;
  onChange: (_: DateNumber) => void;
};

type MouseEventHandler = (e: React.MouseEvent<SVGElement>) => void;

function DateInput(props: DateInputProps) {
  const [controlValue, setControlValue] = useState<string>('');
  const [isInputActive, setIsInputActive] = useState<boolean>(false);

  useEffect(() => {
    setControlValue(props.value.toString());
  }, [props.value]);

  const onInput: InputEventHandler = (e) => {
    const target = e.target as HTMLInputElement;
    setControlValue(target.value);
  }

  const onSave: MouseEventHandler = (e) => {
    const numberValue = parseInt(controlValue);
    if (!isNaN(numberValue)) {
      props.onChange(numberValue);
    }
    setIsInputActive(false);
  };

  const onPrevClick: MouseEventHandler = (e) => {
    const newValue = richDate.plus({ days: -1 });
    props.onChange(getDateNumber(newValue));
  };

  const onNextClick: MouseEventHandler = (e) => {
    const newValue = richDate.plus({ days: 1 });
    props.onChange(getDateNumber(newValue));
  };

  const onTodayClick: MouseEventHandler = (e) => {
    props.onChange(getDateNumber());
  };

  const richDate: DateTime = parseDateNumber(props.value);
  const dateString = richDate.toFormat('DDDD');
  const shortDateString = richDate.toFormat('M/d/yyyy');
  const specialClassName = classnames(styles.entryInput, styles['entryInput-special']);

  return (
    <>
      <Row>
        <Col className={specialClassName}>
          <strong>{dateString}</strong>
        </Col>
      </Row>
      <Form.Group as={Row} className={specialClassName}>
        <Col xs="auto">
          <Icon.ArrowLeftSquareFill className={styles.entryInputIcon} size={38} onClick={onPrevClick} />
        </Col>
        {isInputActive && (
          <>
            <Col>
              <Form.Control type="number" value={controlValue} onInput={onInput} />
            </Col>
            <Col xs="auto">
              <Icon.CheckSquareFill className={styles['entryInputIcon-blue']} size={38} onClick={onSave} />
            </Col>
          </>
        )}
        {!isInputActive && (
          <>
            <Col>
              <Form.Control value={shortDateString} readOnly onClick={() => setIsInputActive(true)} />
            </Col>
            <Col xs="auto" style={{ alignSelf: 'center' }}>
              <Icon.ClockFill className={styles.entryInputIcon} size={32} onClick={onTodayClick} />
            </Col>
          </>
        )}
        <Col xs="auto">
          <Icon.ArrowRightSquareFill className={styles.entryInputIcon} size={38} onClick={onNextClick} />
        </Col>
      </Form.Group>
    </>
  );
}

export default DateInput;